import { render, staticRenderFns } from "./MitarbeiterMediaBadge.vue?vue&type=template&id=42367c94&scoped=true"
import script from "./MitarbeiterMediaBadge.vue?vue&type=script&lang=js"
export * from "./MitarbeiterMediaBadge.vue?vue&type=script&lang=js"
import style0 from "./MitarbeiterMediaBadge.vue?vue&type=style&index=0&id=42367c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42367c94",
  null
  
)

export default component.exports